import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { apiClient } from "@apis/apiClient";
import SntHideLongText from "@/components/ReactBootstrap/SntHideLongText";
import StringUtils from "@/utils/StringUtils";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";
import { SearchDataCategory } from "./types";

interface SearchItemProps {
  dataSearch: SearchDataCategory;
  closePopup: () => void;
  isRecent: boolean;
  strSearch?: string;
}

function SearchItem({
  dataSearch,
  closePopup,
  isRecent,
  strSearch,
}: SearchItemProps) {
  const history = useHistory();
  const [showMoreButton, setShowMoreButton] = useState(true);
  const [list, setList] = useState(dataSearch?.listItem.slice(0, 4) || []);
  const [listData] = useState(dataSearch?.listItem || []);
  const [maxList] = useState(dataSearch.listItem.length);
  const [limitList, setLimitList] = useState(8);

  const showMore = () => {
    setList(listData.slice(0, limitList + maxList));
    setLimitList(limitList + maxList);
    if (listData.slice(0, limitList + maxList).length === maxList) {
      setShowMoreButton(false);
    }
  };

  const showLess = () => {
    setList(listData.slice(0, 4));
    setLimitList(4);
    setShowMoreButton(true);
  };

  const searchRender = useMemo(() => {
    const categoryKey = `search_category_${dataSearch.name}_name` as LanguageKey;
    const translatedCategory = translate(categoryKey);
    // If translate returns the key itself, it means no translation exists - use the name as-is
    const displayName =
      translatedCategory !== categoryKey ? translatedCategory : dataSearch.name;

    return (
      <>
        <a href="##">{displayName}</a>
        <ul className="ms-3">
          {list.map((item, index) => {
            return (
              <a
                key={index}
                href={apiClient.defaults.baseURL + item.link}
                className="chat-name"
                onClick={(e) => {
                  e.preventDefault();
                  history.push(item.link);
                  closePopup();
                }}
                title={item?.data.title}
              >
                <li id={item?.id?.toString()}>
                  <div style={{ overflow: "hidden" }}>
                    {item?.img}
                    <div>
                      <SntHideLongText>{item?.data.title}</SntHideLongText>
                      <p style={{ margin: 0 }} className="subtitle-text">
                        {item?.data.subtitle
                          ? item?.data.subtitle
                          : item?.data.title}
                      </p>
                    </div>
                  </div>
                </li>
              </a>
            );
          })}
        </ul>
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch, list]);

  useEffect(() => {
    if (isRecent) {
      setList(dataSearch.listItem);
    } else {
      setList(dataSearch.listItem.slice(0, 4));
    }
  }, [dataSearch, dataSearch.listItem, isRecent]);

  return (
    <div>
      <li>
        {searchRender}
        {showMoreButton && maxList > 4 && (
          <a
            className="more "
            href="# "
            onClick={(e) => {
              e.preventDefault();
              showMore();
            }}
            style={{ color: "#5094BE", fontSize: 14, fontWeight: "normal" }}
          >
            {!isRecent &&
              strSearch &&
              StringUtils.replaceStr(
                translate(LanguageKey.v41_view_all_matching_key),
                dataSearch.name.toLowerCase()
              ) +
                ' "' +
                strSearch +
                '"'}
          </a>
        )}
        {!showMoreButton && (
          <a
            className="more "
            href="# "
            onClick={(e) => {
              e.preventDefault();
              showLess();
            }}
            style={{ color: "#5094BE", fontSize: 14, fontWeight: "normal" }}
          >
            <u>{translate(LanguageKey.v41_show_less_key)}</u>
          </a>
        )}
      </li>
    </div>
  );
}

export default SearchItem;
